import type { IconName } from '../components/Icons';

/** `isLink` value that marks a URL item (not a downloadable file). */
export const FILE_LINK_IS_LINK = 1;

const EXTENSION_ICON_MAP: Record<string, IconName> = {
  pdf: 'pdf',
  xlsx: 'excel',
  xls: 'excel',
  docx: 'fileWord',
  doc: 'fileWord',
};

/**
 * Maps a file extension (or link flag) to its `Icon` name. Same mapping as
 * aosphere-nextgenui-user's `resolveFileExtensionIconName`.
 */
export function resolveFileExtensionIconName(extension: string, isLink = 0): IconName {
  if (isLink === FILE_LINK_IS_LINK || extension.toLowerCase() === 'link') {
    return 'link';
  }

  return EXTENSION_ICON_MAP[extension.toLowerCase()] ?? 'pdf';
}
